module.exports = __webpack_public_path__ + "src/assets/img/dahsolar_img.2e77289a.jpg";